import React from 'react';

import Title from '../../components/Title';
import GoalSplitRows from './components/GoalSplitRows';
import { sdgCardColorClass } from '../../utils/helpers';

export default function Goals({
  locales: {
    sustainability: { sdgs, strategy },
  },
}) {
  // Rather than iterating through them at render time, we prepare the goals array here, it's like only relaly for the color class anyway
  const goals = sdgs.map((item, index) => ({
    key: index,
    title: item.title,
    description: item.description,
    colorClass: sdgCardColorClass(index + 1),
  }));

  return (
    <div className="bmc-page-goals">
      {/* Uncomment for SDG's and SDG Header */}
      {/* <div className="bmc-page-goals-header">
        <i className="icon-Earth" />
        <i className="icon-SD" />
        <Icon className="icon-Goals" pathCount={20} />
      </div>

      <div className="bmc-page-goals-items-wrapper">
        <div className="bmc-page-goals-items">
          {sdgs.map((item, index) => (
            <div
              key={index}
              className={classNames(
                'bmc-page-goals-items-goal sdg-card sdg-card--small',
              )}
            >
              <div className="flip-inner">
                <div
                  className={classNames(
                    'flip-front ',
                    `sdg-card-color-${index + 1}`,
                  )}
                >
                  <div className="flip-front-icon">
                    <SvgIcon name={`sdg${index + 1}`} />
                  </div>
                  <div className="flip-front-title">{item.title}</div>
                </div>
                <div
                  className={classNames(
                    'flip-back',
                    `sdg-card-color-${index + 1}`,
                  )}
                >
                  {item.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <Title text={strategy.tabs.goalTitlePlural} />
      <GoalSplitRows goals={goals} twoCol />
    </div>
  );
}
